<template>
    <div class="bridgeBox">
        <div class='contBox mainbridgeBox'>
            <v-head ref="vhead"></v-head>
            <div class="contentBox">
                <div class='bridgeBanner'>
                    <h2>{{$t('m.Bridge')}}</h2>
                    <!-- <p>{{$t('m.t128')}}</p> -->
                    <!-- <p>{{$t('m.t129')}}</p> -->
                    <p>Here're some bridges to transfer assets. </p>
                    <p>Please do your own research before using.</p>
                    <div class="swapBox">
                        <a class='btn2' id="a1" href="https://scroll.io/portal" target="_block"><img src="../../images/wallet/scrollLogoYYY.png" alt="" srcset=""> Scroll Portal <i class="el-icon-right" style="font-size:16px;"></i></a>
                        <div class="line"></div>
                        <a class='btn2' id="a2" href="https://portal.zksync.io" target="_block"><img src="../../images/wallet/zksyncLogoYYY.png" alt="" srcset=""> zkSync Era Portal <i class="el-icon-right" style="font-size:16px;"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="migrationGuide">
            <div class="contentBox">
                <div class="warp">
                    <h1>SPACE / xSPACE / Planet NFT Migration Guide</h1>
                    <h3>To distinguish between the assets of 1.0 and 2.0, SpaceFi 2.0 will issue a new token named STAR. It inherits the supply, distribution, etc., from SPACE (1.0) and will be exchanged at a 1:1 ratio with SPACE.</h3>
                    <a href="https://space-finance.medium.com/spacefi-2-0-product-update-migration-introduction-f551c3ddf4e0" target="_balck">Learn More >></a>
                </div>
            </div>
        </div>
        <div class="Migration">
            <div class="center connectBoxW contentBox">
                <div class="titlebox">
                    <h1>Migrate from SpaceFi 1.0 to 2.0</h1>
                    <p></p>
                </div>
                <div class="tabs">
                    <div>
                        <span :class="actIndex == 0 ? 'act' : ''" @click="actIndex = 0;selectNames = [];selectNFTIds = []">Planet NFT</span>
                    </div>
                    <div>
                        <span :class="actIndex == 2 ? 'act' : ''" @click="actIndex = 2;sendxSpaceNum = null">{{xtokenSymbol}} Token</span>
                    </div>
                    <div>
                        <span :class="actIndex == 1 ? 'act' : ''" @click="actIndex = 1;sendSpaceNum = null;">{{tokenSymbol}} Token</span>
                    </div>
                    
                </div>
                <div class="route">
                    <div class="left">
                        <p>From</p>
                        <div>
                            <img src="../../images/bridge/zksyncLogo111.png" alt="">
                            <span>SpaceFi </span>
                            <span> 1.0</span>
                        </div>
                    </div>
                    <div class="center">
                        <i class="el-icon-right"></i>
                    </div>
                    <div class="right">
                        <p>To</p>
                        <div>
                            <img src="../../images/bridge/zksyncLogo111.png" alt="">
                            <span>SpaceFi </span>
                            <span> 2.0</span>
                        </div>
                    </div>
                </div>
                <div class="tabItems">
                    <div v-if="actIndex == 0" class="nftBox">
                        <p  @click="messageShow = true;getNFTData()">
                            <span>Select an NFT :</span>
                            <span>
                                <i v-for="(item,index) in selectNames" :key="index">
                                    {{item}}{{index == selectNames.length-1 ? '' : ','}}
                                </i>
                            </span>
                            <i class="el-icon-caret-bottom"></i>
                        </p>
                    </div>
                    <div v-if="actIndex == 1" class="spaceBox">
                        <div class="balance">
                            Balance: {{SPACEBalance}} SPACE
                        </div>
                        <p>
                            <span>Send :</span>
                            <input type="number" v-model="sendSpaceNum" placeholder="Please input">
                            <span class="max" @click="sendSpaceNum = SPACEBalance">max</span>
                        </p>
                    </div>
                    <div v-if="actIndex == 2" class="xspaceBox">
                        <div class="balance">
                            Balance: {{xSPACEBalance}} xSPACE
                        </div>
                        <p>
                            <span>Send :</span>
                            <input type="number" v-model="sendxSpaceNum" placeholder="Please input">
                            <span class="max" @click="sendxSpaceNum = xSPACEBalance">max</span>
                        </p>
                    </div>
                </div>
                <div class="btns">
                    <button v-if="actIndex == 0" :class="selectNFTIds.length == 0 ? '' : 'action'" @click="migrationNFT">Migration <i v-if="migrationNFTLoading" style="margin-left: 5px;color:#fff;" class="el-icon-loading"></i> </button>
                    <button v-if="actIndex == 1" :class="!sendSpaceNum ? '' : 'action'" @click="migrationStarToken">Migration <i v-if="migrationSPACELoading" style="margin-left: 5px;color:#fff;" class="el-icon-loading"></i> </button>
                    <button v-if="actIndex == 2" :class="!sendxSpaceNum ? '' : 'action'" @click="migrationxStarToken">Migration <i v-if="migrationxSPACELoading" style="margin-left: 5px;color:#fff;" class="el-icon-loading"></i> </button>
                </div>
            </div>
        </div>
        <div class="bridgeContentBox">
            <div class="contentBox ">
                <div class="transferContent" style="display:none;">
                    <div class="transferTitle">
                        <p>Transfer</p>
                        <p>Specifically for transferring Planet NFT and SPACE assets between Evmos and zkSync.</p>
                    </div>
                    <div class="tabs">
                        <div :class="tabIndex == 1 ? 'act' : ''" @click="tabs(1)">Planet NFT</div>
                        <div style="color: #8b8b8b;" :class="tabIndex == 0 ? 'act' : ''" @click="tabs(0)">SPACE token</div>
                    </div>
                    <div v-if="tabIndex == 0">
                        <v-transferstar></v-transferstar>
                    </div>
                    <div v-if="tabIndex == 1">
                        <v-transfernft></v-transfernft>
                    </div>
                </div>

                <div class="EVMContent" style="display:block;">
                    <div class="Subtitle">
                        <img src="../../images/bridge/zksyncLogo.png" alt="">
                        <p>Bridges for zkSync Era</p>
                    </div>
                    <ul>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/orbiter.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Orbiter</p>
                                        <a href="https://www.orbiter.finance/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism / Starknet / Loopring</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/rhino.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Rhino</p>
                                        <a href="https://app.rhino.fi/bridge/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Scroll / Ethereum / Arbitrum One / BNB Smart Chain / Base / Linea / Optimism / Polygon</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/celer.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Celer</p>
                                        <a href="https://cbridge.celer.network/56/324/BNB" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism / Aptos</div>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/multichain.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Multichain</p>
                                        <a href="https://app.multichain.org/#/router" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism / Aptos</div>
                                </div>
                            </div>
                        </li> -->
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/bungee.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Bungee</p>
                                        <a href="https://www.bungee.exchange/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/finance.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>XY Finance</p>
                                        <a href="https://app.xy.finance/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Scroll / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/OmniBTC.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>OmniBTC</p>
                                        <a href="https://app.omnibtc.finance/swap" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/Across.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Across</p>
                                        <a href="https://www.across.to/bridge" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>zkSync Era / Base / Ethereum / Polygon / Arbitrum / Optimism</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="EVMContent">
                    <div class="Subtitle">
                        <img style="height:34px;" src="../../images/bridge/scrollLogo.png" alt="">
                        <p>Bridges for Scroll</p>
                    </div>
                    <ul>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/rhino.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Rhino</p>
                                        <a href="https://app.rhino.fi/bridge/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Scroll / zkSync Era / Ethereum / Arbitrum One / BNB Smart Chain / Base / Linea / Optimism / Polygon</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/orbiter.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Orbiter</p>
                                        <a href="https://www.orbiter.finance/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Scroll / zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism / Starknet / Loopring</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/finance.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>XY Finance</p>
                                        <a href="https://app.xy.finance/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Scroll / zkSync Era / Ethereum / BNB Chain / Polygon / Arbitrum / Optimism</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/Owlto.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>Owlto</p>
                                        <a href="https://owlto.finance/bridge" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Scroll / Ethereum / Starknet / Base / Linea / zkSync Era / Arbitrum / Optimism / Polygon zkEVM / Zora / Kroma</div>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/celer.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>{{$t('m.t135')}}</p>
                                        <a href="https://cbridge.celer.network/#/transfer" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Evmos / BNB / Avalanche / Fantom</div>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
                <div class="EVMContent">
                    <div class="Subtitle">
                        <img src="../../images/bridge/evmosLogo.png" alt="">
                        <p>{{$t('m.t131')}}</p>
                    </div>
                    <ul>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/Axelar.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>{{$t('m.t133')}}</p>
                                        <a href="https://satellite.money" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Evmos / Ethereum / BNB / Cosmos / Osmosis / Arbitrum / Polygon</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/Graviety.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>{{$t('m.t134')}}</p>
                                        <a href="https://www.gravitybridge.net/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Evmos / Ethereum / Cosmos / Osmosis</div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/celer.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>{{$t('m.t135')}}</p>
                                        <a href="https://cbridge.celer.network/#/transfer" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Evmos / BNB / Avalanche / Fantom</div>
                                </div>
                            </div>
                        </li>
                        <!-- <li>
                            <div class="itemsCon">
                                <div class="imgBox">
                                    <img src="../../images/bridge/multichain.png" alt="">  
                                </div>
                                <div class="conBox">
                                    <div>
                                        <p>{{$t('m.t137')}}</p>
                                        <a href="https://multichain.org/" target="_block">{{$t('m.t130')}}</a>
                                    </div>
                                    <div>Evmos / Ethereum</div>
                                </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
            </div>
            
        </div>
        <v-footer></v-footer>
        <div class="farmMessageBox" v-if="messageShow" @click="messageShow = false;">
            <div class=" contentBox">
                <div class="warp" @click.stop>
                    <div class="selectannft">
                        <div class="titlebox">
                            <h1>
                                Select an NFT
                                <i class="el-icon-close" @click="messageShow = false;"></i>
                            </h1>
                        </div>
                        <div class="inputBox">
                            <input type="text" v-model="searchName" placeholder="search by NFT name" @keyup.enter="searchNFT()">
                            <i v-if="searchName != ''" class="el-icon-circle-close" style="margin-right:10px;" @click="searchName = '';searchNFT()"></i>
                            <i class="el-icon-search" @click="searchNFT()"></i>
                        </div>
                        <div class="selectAll"  v-if="nftsList.length != 0">
                            <!-- <p @click="selectAllBtn">
                                <i :class="selectAll ? 'el-icon-success' : 'el-icon-circle-check'"></i>
                                Select all
                            </p> -->
                            <i class="el-icon-warning"></i>&nbsp;Migrate up to 5 nft in a single pass
                        </div>
                        <div class="nfts">
                            <div v-if="nftsLoading && nftsList.length == 0">
                                <i class="el-icon-loading"></i>
                            </div>
                            <p v-if="!nftsLoading && nftsList.length == 0"> No data yet</p>
                            <ul v-if="!nftsLoading && nftsList.length != 0">
                                <li v-for="(item,index) in nftsList" :key="index" @click="selectItem(index)">
                                    <img :src="item.nftUrl" alt="">
                                    <i :class="item.select ? 'el-icon-success' : 'el-icon-circle-check'"></i>
                                </li>
                                <li v-if="nftsList.length%3 > 0"></li>
                                <li v-if="nftsList.length%3 > 1"></li>
                            </ul>
                        </div>
                        <div class="btnbox" v-if="nftsList.length != 0">
                            <div class="confirmbtn" @click="messageShow = false;selectOk()">OK</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import Web3 from 'web3';
import { 
    judgeNetwork, getAllowance, setApprove,
    nftBalanceOf, tokenOfOwnerByIndex, gettokenURI, MigrateNFT,
    getBalanceOf, 
    MigrateStarToken, MigrateXStarToken
} from '../../spaceevmostest.js'
    export default {
        data() {
            return {
                tabIndex:1,

            tokenSymbol:'',xtokenSymbol:'',
            actIndex: 0,
            messageShow:false,
            nftsLoading:true,
            selectNames:[],
            selectNFTIds:[],
            searchName:'',
            migrationNFTLoading:false,
            migrationSPACELoading:false,
            migrationxSPACELoading:false,
            nfts:[],
            nftsList:[],
            selectAll:false,
            SPACEBalance:0,sendSpaceNum:null,
            xSPACEBalance:0,sendxSpaceNum:null,
            }
        },
        mounted(){
            localStorage.setItem('0x339299',1)
            this.userAddress = localStorage.getItem('userAddress')
        this.tokenSymbol = 'STAR'
        this.xtokenSymbol = 'xSTAR'
        this.nftInfoList = window.nftData.cardListMainnet
        this.migrateAddress = '0xbC0Df13b5A726943fdc8DBaFA2bC126E3cCe831f'
        this.oldTokenAddress = '0x47260090cE5e83454d5f05A0AbbB2C953835f777'
        this.oldxTokenAddress = '0x6aF43486Cb84bE0e3EDdCef93d3C43Ef0C5F63b1'
        this.oldnftAddress = '0xf25Fd31C869ce1238B4E30e3c8745BFe570e40e1'
        if(this.userAddress){
            getBalanceOf(this.oldTokenAddress,this.userAddress).then(res => {
                this.SPACEBalance = this.$BigNumber(res).div(Math.pow(10,18))
            }).catch(err => {
                console.log(err)
            })
            getBalanceOf(this.oldxTokenAddress,this.userAddress).then(res => {
                this.xSPACEBalance = this.$BigNumber(res).div(Math.pow(10,18))
            }).catch(err => {
                console.log(err)
            })
        }
        },
        methods: {
        getNFTData(){
            this.nftsLoading = true
            this.nfts = []
            this.nftsList = []
            if(this.userAddress){
                nftBalanceOf(this.oldnftAddress,this.userAddress).then(nftBalanceOf => {
                    //console.log(nftBalanceOf)
                    if(nftBalanceOf == 0){
                        this.nftsLoading = false
                        return false
                    }
                    for (let i = 0; i < nftBalanceOf; i++) {
                        tokenOfOwnerByIndex(this.oldnftAddress,i,this.userAddress).then(NFTId => {
                            gettokenURI(this.oldnftAddress,NFTId).then(nftUrl => {
                                //console.log(NFTId,nftUrl)
                                var obj = {
                                    NFTId,
                                    nftUrl,
                                    select: false
                                }
                                this.selectNFTIds.forEach((item,index) => {
                                    if(item == NFTId){
                                        obj.select = true
                                    }
                                })
                                this.nftInfoList.forEach((item,index) => {
                                    if (item.cid == nftUrl.split('/')[3]) {
                                        obj.name = item.nameEn
                                    }
                                })
                                this.nfts.push(obj)
                                this.dataSort(this.nfts)
                                //console.log(this.nfts)
                                this.nftsList = this.nfts
                                this.nftsLoading = false
                            })
                        })
                    }
                })
            } else {
                this.nftsLoading = false
            }
        },
        selectItem(index){
            var num = 0
            this.nftsList.forEach((item,index) => {
                if(item.select){
                    num += 1
                }
            })
            console.log(num)
            if( num >= 5 && !this.nftsList[index].select ){
                this.$message({
                    type:"warning",
                    message:"Migrate up to 5 nft in a single pass"
                })
                return false
            }
            this.$set(this.nftsList[index],'select',!this.nftsList[index].select)
            this.selectAll = this.nftsList.every((item,index) => {
                return item.select
            })
            //console.log(index)
            // this.$set(this.nftsList[index],'select',!this.nftsList[index].select)
            // this.selectAll = this.nftsList.every((item,index) => {
            //     return item.select
            // })
            //console.log(aaa)

        },
        selectOk(){
            this.selectNames = []
            this.selectNFTIds = []
            this.nftsList.forEach((item,index) => {
                if(item.select){
                    this.selectNames.push(item.name)
                    this.selectNFTIds.push(item.NFTId)
                }
            })
        },
        selectAllBtn(){
            this.selectAll = !this.selectAll
            this.nftsList.forEach((item,index) => {
                item.select = this.selectAll
            })
        },
        migrationNFT(){
            if(this.selectNFTIds.length == 0){ return false }
            if(this.migrationNFTLoading){ return false }
            this.migrationNFTLoading = true
            judgeNetwork().then(res => {
                if (res == 0) {
                    this.migrationNFTLoading = false
                    return false
                }
                MigrateNFT(this.migrateAddress,this.selectNFTIds,this.userAddress).then(res => {
                    this.migrationNFTLoading = false
                    this.selectNames = []
                    this.selectNFTIds = []
                    this.$message({ type: 'success', message: 'Migrate success' });
                }).catch(error => {
                    this.migrationNFTLoading = false
                })
            })
        },
        migrationStarToken(){
            if(!this.sendSpaceNum){ 
                this.$message({ message:'Please input', type:'warning' })
                return false 
            }
            if(Number(this.SPACEBalance) < Number(this.sendSpaceNum)){ 
                this.$message({ message:'Insufficient Balance', type:'warning' })
                return false 
            }
            if(this.migrationSPACELoading){ return false }
            this.migrationSPACELoading = true
            judgeNetwork().then(res => {
                if (res == 0) {
                    this.migrationSPACELoading = false
                    return false
                }
                getAllowance(this.oldTokenAddress ,this.migrateAddress, this.userAddress).then(res => {
                    //console.log(res)
                    if (Number(res/Math.pow(10,18))>Number(this.sendSpaceNum)) {
                        this.tokenMigrateStar()
                    } else {
                        setApprove(this.oldTokenAddress,this.migrateAddress,this.userAddress ).then(res => {
                            this.tokenMigrateStar()
                        },error => {
                            this.migrationSPACELoading = false
                        }).catch(error => {
                            this.migrationSPACELoading = false
                        })
                    }
                })
            })
        },
        tokenMigrateStar(){
            var _sendSpaceNum = Web3.utils.toBN( this.$BigNumber(this.sendSpaceNum).multipliedBy(this.$BigNumber(Math.pow(10,18))))
            MigrateStarToken(this.migrateAddress,_sendSpaceNum,this.userAddress).then(res => {
                this.migrationSPACELoading = false
                getBalanceOf(this.oldTokenAddress,this.userAddress).then(res => {
                    this.SPACEBalance = res/Math.pow(10,18)
                })
                this.sendSpaceNum = null
                this.$message({ type: 'success', message: 'Migrate success' });
            }).catch(error => {
                this.migrationSPACELoading = false
            })
        },
        migrationxStarToken(){
            if(!this.sendxSpaceNum){ 
                this.$message({ message:'Please input', type:'warning' })
                return false 
            }
            if(Number(this.xSPACEBalance) < Number(this.sendxSpaceNum)){ 
                this.$message({ message:'Insufficient Balance', type:'warning' })
                return false 
            }
            if(this.migrationxSPACELoading){ return false }
            this.migrationxSPACELoading = true
            judgeNetwork().then(res => {
                if (res == 0) {
                    this.migrationxSPACELoading = false
                    return false
                }
                getAllowance(this.oldxTokenAddress ,this.migrateAddress, this.userAddress).then(res => {
                    //console.log(res)
                    if (Number(res/Math.pow(10,18))>Number(this.sendxSpaceNum)) {
                        this.tokenMigratexStar()
                    } else {
                        setApprove(this.oldxTokenAddress,this.migrateAddress,this.userAddress ).then(res => {
                            this.tokenMigratexStar()
                        },error => {
                            this.migrationxSPACELoading = false
                        }).catch(error => {
                            this.migrationxSPACELoading = false
                        })
                    }
                })
            })
        },
        tokenMigratexStar(){
            var _sendxSpaceNum = Web3.utils.toBN( this.$BigNumber(this.sendxSpaceNum).multipliedBy(this.$BigNumber(Math.pow(10,18))))
            MigrateXStarToken(this.migrateAddress,_sendxSpaceNum,this.userAddress).then(res => {
                this.migrationxSPACELoading = false
                getBalanceOf(this.oldxTokenAddress,this.userAddress).then(res => {
                    this.xSPACEBalance = res/Math.pow(10,18)
                })
                this.sendxSpaceNum = null
                this.$message({ type: 'success', message: 'Migrate success' });
            }).catch(error => {
                this.migrationxSPACELoading = false
            })
        },
        searchNFT(){
            //console.log(12313)
            if(this.searchName == ''){
                this.nftsList = this.nfts
                return
            }
            this.nftsList = []
            this.nftsLoading = true
            this.nfts.forEach((item,index) => {
                //console.log(item)
                if(this.searchName.toLowerCase() == item.name.toLowerCase() || this.searchName == item.NFTId){
                    this.nftsList.push(item)
                    this.$forceUpdate()
                }
            })
            this.nftsLoading = false
        },
        
        goDetail(link){
            window.open(link,'_block')
        },
        dataSort(arr){
            arr.sort((a ,b) => {
                if (Number(a.NFTId) > Number(b.NFTId)) {
                    return -1
                } else if (Number(a.NFTId) < Number(b.NFTId)) {
                    return 1
                }
            })
        },
            tabs(a){
                // if(a == 0){
                //     this.$message({
                //         type:'warning',
                //         message:'SPACE token bridging is not recovered yet.'
                //     })
                //     return false
                // } else {
                    this.tabIndex = a
                // }
                
            }
        },
    }
</script> 
<style scoped>

</style>